/* eslint-disable @next/next/no-img-element */
import { FB_PIXEL_IDS } from "@/lib/fpixel";
import { PINTEREST_TAG_ID } from "@/lib/ppixel";
import Script from "next/script";
import React from "react";
import { selectGamize } from "@/store/slices/gamize";
import { useSelector } from "react-redux";
import { selectAuth } from "@/store/slices/auth";

const ExternalScripts = () => {
  const gamizeState = useSelector(selectGamize);
  const authState = useSelector(selectAuth);

  React.useEffect(() => {
    if (typeof window !== "undefined" && authState.user?.email) {
      window.pintrk?.("load", PINTEREST_TAG_ID, {
        em: authState.user.email.toLowerCase().trim()
      });
    }
  }, [authState.user?.email]);

  return (
    <>
      <Script id="fb-pixel" strategy="afterInteractive">
        {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window,document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');

            ${FB_PIXEL_IDS.map((v) => `fbq('init', ${v});`).join("")}
          `}
      </Script>
      {/* Pinterest Tag */}
      <Script id="pinterest-pixel" strategy="afterInteractive">
        {`
          !function(e){if(!window.pintrk){window.pintrk = function () {
          window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
          n=window.pintrk;n.queue=[],n.version="3.0";var
          t=document.createElement("script");t.async=!0,t.src=e;var
          r=document.getElementsByTagName("script")[0];
          r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
          pintrk('load', '${PINTEREST_TAG_ID}', ${authState.user?.email ? JSON.stringify({ em: authState.user.email.toLowerCase().trim() }) : "{}"});
          pintrk('page');
        `}
      </Script>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          alt=""
          src={`https://ct.pinterest.com/v3/?event=init&tid=${PINTEREST_TAG_ID}&noscript=1`}
        />
      </noscript>
      {/* End Pinterest Tag */}
      {/* Google Tag Manager */}
      <Script
        strategy="afterInteractive"
        src="https://www.googletagmanager.com/gtag/js?id=GTM-P69KMZ9"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'GTM-P69KMZ9', {'allow_enhanced_conversions':true});
        `}
      </Script>
      {/* End Google Tag Manager */}
      {/* Google tag (gtag.js) - PERFECT LOVE */}
      <Script
        strategy="afterInteractive"
        src="https://www.googletagmanager.com/gtag/js?id=AW-18497915631"
      />
      <Script id="gtag-perfect-love" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-18497915631');
        `}
      </Script>
      {/* End Google tag (gtag.js) - PERFECT LOVE */}
      {/* Google tag (gtag.js) - ASTRO */}
      <Script
        strategy="afterInteractive"
        src="https://www.googletagmanager.com/gtag/js?id=AW-18495803669"
      />
      <Script id="gtag-astro" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-18495803669');
        `}
      </Script>
      {/* End Google tag (gtag.js) - ASTRO */}
      {/* Meta Pixel Code - 2669816183472675 */}
      <Script id="meta-pixel-2669816183472675" strategy="afterInteractive">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '2669816183472675');
          fbq('track', 'PageView');
        `}
      </Script>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          alt=""
          src="https://www.facebook.com/tr?id=2669816183472675&ev=PageView&noscript=1"
        />
      </noscript>
      {/* End Meta Pixel Code - 2669816183472675 */}
      {/* Meta Pixel Code - 1130145769511521 */}
      <Script id="meta-pixel-1130145769511521" strategy="afterInteractive">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1130145769511521');
          fbq('track', 'PageView');
        `}
      </Script>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          alt=""
          src="https://www.facebook.com/tr?id=1130145769511521&ev=PageView&noscript=1"
        />
      </noscript>
      {/* End Meta Pixel Code - 1130145769511521 */}
      <Script strategy="afterInteractive" id="db-page-scripts">
        {`
          function mGoldBookingBtnClick() {
            var x = document.getElementsByClassName("mGoldBookingCheck")[0].checked;
            if (x) {
              window.location.href = "https://sencogoldanddiamonds.com/gold-booking/";
            } else {
              alert("You must accept the terms and conditions to proceed");
            }
          }

          function mSilverBookingBtnClick() {
            var x = document.getElementsByClassName("mSilverBookingCheck")[0].checked;
            if (x) {
              window.location.href = "https://sencogoldanddiamonds.com/silver-booking/";
            } else {
              alert("You must accept the terms and conditions to proceed");
            }
          }
          function openCity(evt, cityName) {
            var i, tabcontent, tablinks;
            tabcontent = document.getElementsByClassName("tabcontent");
            for (i = 0; i < tabcontent.length; i++) {
                tabcontent[i].style.display = "none";
            }
            tablinks = document.getElementsByClassName("tablinks");
            for (i = 0; i < tablinks.length; i++) {
                tablinks[i].className = tablinks[i].className.replace(" active", "");
            }
            document.getElementById(cityName).style.display = "block";
            evt.currentTarget.className += " active";
          }

          function irShowSection(id) {
            const ids = ['FinancialResults', 'GroupCompanyFinancials', 'AppointmentIndependentDirector', 'AnnualReturnMGT', 'Prospectus', 'TradingWindowClosure', 'Recordings', 'NewspaperPublications', 'InvestorsContact'];
            ids.forEach(v => {
                if (document.getElementById(v)) {
                    document.getElementById(v).style.display = 'none';
                }
            });
            if (document.getElementById(id)) {
                document.getElementById(id).style.display = 'block';
            }
          }

          function importantDisclaimerBtnClick() {
            const confirmRadio = document.getElementById("important-disclaimer-confirm");
            const notConfirmRadio = document.getElementById("important-disclaimer-not-confirm");
            document.getElementById("important-disclaimer-message").innerText = "";
            
            if (confirmRadio.checked) {
              const urlParams = new URLSearchParams(window.location.search);
              const redirectUrl = urlParams.get("redirect");
              
              if (redirectUrl) {
                window.location.href = redirectUrl;
              }
            } else if (notConfirmRadio.checked) {
              document.getElementById("important-disclaimer-message").innerText = "You are not permitted to view the materials in this section of the website.";
            }
          }

          function placementDisclaimerBtnClick() {
            const confirmRadio = document.getElementById("placement-disclaimer-confirm");
            const notConfirmRadio = document.getElementById("placement-disclaimer-not-confirm");
            document.getElementById("placement-disclaimer-message").innerText = "";
            
            if (confirmRadio.checked) {
              const urlParams = new URLSearchParams(window.location.search);
              const redirectUrl = urlParams.get("redirect");
              
              if (redirectUrl) {
                window.location.href = redirectUrl;
              }
            } else if (notConfirmRadio.checked) {
              document.getElementById("placement-disclaimer-message").innerText = "You are not permitted to view the materials in this section of the website.";
            }
          }
          function placementDocumentDisclaimerBtnClick() {
            const confirmRadio = document.getElementById("placement-document-disclaimer-confirm");
            const notConfirmRadio = document.getElementById("placement-document-disclaimer-not-confirm");
            document.getElementById("placement-document-disclaimer-message").innerText = "";
            
            if (confirmRadio.checked) {
              const urlParams = new URLSearchParams(window.location.search);
              const redirectUrl = urlParams.get("redirect");
              
              if (redirectUrl) {
                window.location.href = redirectUrl;
              }
            } else if (notConfirmRadio.checked) {
              document.getElementById("placement-document-disclaimer-message").innerText = "You are not permitted to view the materials in this section of the website.";
            }
          }
        `}
      </Script>
      {/* Fireworks */}
      <Script async src="https://asset.fwcdn3.com/js/storyblock.js" />
      <Script async src="https://asset.fwcdn3.com/js/embed-feed.js" />
      <Script async src="https://asset.fwcdn3.com/js/fwn.js" />
      {!!gamizeState.gamizeData?.script && (
        <>
          <Script async src={`${process.env.NEXT_PUBLIC_GAMIZE_JS_URL}`} />
          <Script
            async
            src={`${process.env.NEXT_PUBLIC_GAMIZE_API}/custom_gamiz.js`}
            onLoad={() => {
              try {
                //@ts-ignore
                window.loadGamize(
                  gamizeState.gamizeData?.script,
                  authState.user?.mobile
                );
              } catch (error) {}
            }}
          />
        </>
      )}
      {/* <Script strategy="afterInteractive" id="moengage">
        {`!function(e,n,i,t,a,r,o,d){var s=e[a]=e[a]||[];if(s.invoked=0,s.initialised>0||s.invoked>0)return console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"),!1;e.moengage_object=a;var l={},g=function n(i){return function(){for(var n=arguments.length,t=Array(n),a=0;a<n;a++)t[a]=arguments[a];(e.moengage_q=e.moengage_q||[]).push({f:i,a:t})}},u=["track_event","add_user_attribute","add_first_name","add_last_name","add_email","add_mobile","add_user_name","add_gender","add_birthday","destroy_session","add_unique_user_id","moe_events","call_web_push","track","location_type_attribute"],m={onsite:["getData","registerCallback"]};for(var c in u)l[u[c]]=g(u[c]);for(var v in m)for(var f in m[v])null==l[v]&&(l[v]={}),l[v][m[v][f]]=g(v+"."+m[v][f]);r=n.createElement(i),o=n.getElementsByTagName("head")[0],r.async=1,r.src=t,o.appendChild(r),e.moe=e.moe||function(){return(s.invoked=s.invoked+1,s.invoked>1)?(console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"),!1):(d=arguments.length<=0?void 0:arguments[0],l)},r.addEventListener("load",function(){if(d)return e[a]=e.moe(d),e[a].initialised=e[a].initialised+1||1,!0}),r.addEventListener("error",function(){return console.error("Moengage Web SDK loading failed."),!1})}(window,document,"script","https://cdn.moengage.com/webpush/moe_webSdk.min.latest.js","Moengage");
          Moengage = moe({
          app_id:"${process.env.NEXT_PUBLIC_MOENGAGE_ID}" ,
          debug_logs: ${parseInt(
            process.env.NEXT_PUBLIC_MOENGAGE_DEBUG || "1"
          )},
          cluster: "DC_3",
          swPath: "${process.env.NEXT_PUBLIC_BASE_PATH || ""}/serviceworker.js",
          ${
            process.env.NEXT_PUBLIC_BASE_PATH
              ? `swScope: "${process.env.NEXT_PUBLIC_BASE_PATH}/"`
              : ""
          }
          
          });
        `}
      </Script> */}
      <Script
        strategy="afterInteractive"
        src="//cdn.syteapi.com/assets/imajs/imajs.js?a=10580&sig=65702a19b9d335ca4a5304ff&languageCode=en_US"
      />
      <Script
        src="https://cdn.styledotme.com/general/scripts/mirrar-ui.js"
        strategy="afterInteractive"
      ></Script>
      <Script id="mirrar-analytics" strategy="afterInteractive">
        {`
          var _mtm = window._mtm = window._mtm || [];
          _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
          (function() {
            var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
            g.async=true; g.src='https://analytics.mirrar.io/js/container_ytjimotd.js'; s.parentNode.insertBefore(g,s);
          })();
        `}
      </Script>

      <Script
        strategy="afterInteractive"
        src={`${process.env.NEXT_PUBLIC_UNBXD_SDK_CLIENT_SCRIPT}`}
      />
      <Script
        strategy="afterInteractive"
        src="//cdnt.netcoresmartech.com/smartechclient.js"
        onLoad={() => {
          const isProd = process.env.NEXT_PUBLIC_UNBXD_CE_MODE === "production";

          if (isProd) {
            window.smartech(
              "create",
              "ADGMOT35CHFLVDHBJNIG50K96BC91FNV9L66PNH3IDG4LRROFO20"
            );
            window.smartech("register", "2bc6405e8f67927699d47ea74183b66d");
          } else {
            window.smartech(
              "create",
              "ADGMOT35CHFLVDHBJNIG50K969A8S93DIGPB08R2E42GNMUECI5G"
            );
            window.smartech("register", "001a6cb014494a04273466e8e4d2303c");
          }

          window.smartech("identify", "");
        }}
      />
    </>
  );
};

export default ExternalScripts;
